import { ResponseError } from "superagent";

// TODO: remove this file and let dependents directly call from @src/appV2/api/errors
export { getErrorMessage, handleApiError, parseObjectErrorResponse } from "@src/appV2/api/errors";

export function isRequestErrorResponse(error: unknown): error is ResponseError {
  return error instanceof Error && "response" in error && "status" in error;
}
